import React, { Component } from 'react';
import { Well } from 'react-bootstrap';
import { formatToDecimal, roundNumber } from "utils/Number/NumberUtils"

export default class SaleProjection extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const negotiation = this.props.negotiation;
        return (
            <Well bsSize="large">
                <div className="clearfix">
                    <span className="sales-info__label float-left" >Valor del terreno ($): </span>
                    <span className="sales-info__value float-right">
                        {negotiation.totalPriceLabel} &nbsp;
                    <b>{negotiation.maxYearsLabel}</b>
                    </span>
                </div>
                <div className="clearfix">
                    <span className="sales-info__label float-left" >Precio de Venta ($): </span>
                    <span className="sales-info__value float-right">
                        {negotiation.quickPaymentFormatted}
                        &nbsp;
                    <b>{negotiation.selectedYearsLabel}</b>
                    </span>
                </div>

                <div className="clearfix">
                    <span className="sales-info__label float-left">Precio Final ($): </span>
                    <span className="sales-info__value float-right">{negotiation.finalPaymentFormatted}</span>
                </div>

                {negotiation.paymentConditionType === "CREDIT" &&
                    <div className="clearfix">
                        <span className="sales-info__label float-left">Saldo a Financiar ($): </span>
                        <span className="sales-info__value float-right">{negotiation.financeBalanceFormatted}</span>
                    </div>
                }

                {negotiation.paymentConditionType === "CREDIT" &&
                    <div className="product-selected__info">
                        <div className="clearfix">
                            <span className="sales-info__label float-left">Cuota Inicial ($): </span>
                            <span className="sales-info__value float-right">{formatToDecimal(roundNumber(negotiation.initialQuota))}</span>
                        </div>
                        <div className="clearfix">
                            <span className="sales-info__label float-left">Cuota Mensual ($): </span>
                            <span className="sales-info__value float-right">{formatToDecimal(roundNumber(negotiation.monthlyQuota))}</span>
                        </div>
                        <div className="clearfix">
                            <span className="sales-info__label float-left">Cuota Final ($): </span>
                            <span className="sales-info__value float-right">{formatToDecimal(roundNumber(negotiation.finalQuota))}</span>
                        </div>
                    </div>
                }

                {negotiation.paymentConditionType === "CASH" &&
                    <div className="product-selected__info">
                        <div className="clearfix">
                            <span className="sales-info__label float-left">Cuota Final ($): </span>
                            <span className="sales-info__value float-right">{formatToDecimal(roundNumber(negotiation.finalQuota,2))}</span>
                        </div>
                    </div>
                }
            </Well>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/SaleProjection/SaleProjection.jsx